import { useQuery } from '@tanstack/react-query'
import api from '../../api'
import type { Application } from '../../types/applications'

// MongoDB-only guard. Keep the shared useSingleApplication hook untouched.
const useMongoDBApplication = (id: string) =>
	useQuery({
		queryKey: ['applications', id],
		queryFn: () => api.applications.getSingleApplication(id, true),
		// Keep the cached response shape identical to useSingleApplication because
		// both use ['applications', id]. Only the MongoDB observer selects safely.
		select: (data): Application => {
			const application = data.body?.[0] as Application | undefined
			if (
				!application ||
				application.applicationID !== id ||
				application.status === 'ERROR'
			) {
				throw new Error('Unable to load the selected Application.')
			}
			return application
		},
		enabled: Boolean(id),
		retry: false
	})

export default useMongoDBApplication
